import React from 'react'
import ParkingCard from '@components/ParkingCard/ParkingCard.component'
import { DateTime } from 'luxon'
import CarpayOrderDiscount from './CarpayOrderDiscount.component'
import CarpayOrderCardContent from './CarpayOrderCardContent.component'

interface EmptyCarpayOrderCardProps {
    fullPrice: number
    price: number
    isLast: boolean
    currency: string
    priceValidUntil?: string
    voucherDiscount?: number
    whitelistDiscount?: number
    loading?: boolean
}

const EmptyCarpayOrderCard = ({
    priceValidUntil,
    voucherDiscount = 0,
    whitelistDiscount = 0,
    price,
    isLast,
    fullPrice,
    loading = false,
    currency
}: EmptyCarpayOrderCardProps) => {
    let discount
    if (voucherDiscount || whitelistDiscount) {
        discount = (
            <CarpayOrderDiscount
                fullPrice={fullPrice}
                currency={currency}
                voucherDiscount={voucherDiscount}
                whitelistDiscount={whitelistDiscount}
            />
        )
    }

    return (
        <ParkingCard loading={loading} isLast={isLast}>
            <ParkingCard.Header>
                <ParkingCard.HeaderText>Ticket gültig bis</ParkingCard.HeaderText>
                <ParkingCard.HeaderText>
                    {priceValidUntil ? DateTime.fromISO(priceValidUntil).toFormat('dd.MM.yyyy') : '-'}
                </ParkingCard.HeaderText>
            </ParkingCard.Header>
            <CarpayOrderCardContent title="Aktueller Preis" currency={currency} price={price} discount={discount} />
        </ParkingCard>
    )
}

export default EmptyCarpayOrderCard
